import getters from './getters';
import mutations from './mutations';
import state from './state';

const vuexStore = {
	namespaced: true,
	state,
	getters,
	mutations,
};

type ErrorsBag = Record<string, string[] | string>;
type FieldErrors = string | string[] | undefined | null;
type FormError = {
	message: string;
	type: 'error';
};

type State = {
	validationErrors: ErrorsBag;
	formError: FormError;
};

/* eslint-disable @typescript-eslint/naming-convention */
type Getters = {
	'validation/validationErrors': ErrorsBag;
	'validation/formError': FormError;
};

type Mutations = {
	(name: 'validation/resetValidationError', key: string): void;
	(name: 'validation/resetValidationErrors'): void;
	(name: 'validation/resetFormError'): void;
};

type ValidationStore = {
	state: State;
	getters: Getters;
	commit: Mutations;
};

export { vuexStore as default, ValidationStore, ErrorsBag, FieldErrors, FormError };
